import type { CSSProperties } from 'react';
import type { CatalogTool } from '../../api/catalogApi';
import { CH, TOOL_ART, artIndex, char, ic } from './art';
import Raw from './Raw';

const HUES = [355, 25, 215, 275, 165, 335, 45];

interface ToolCardProps {
  sectionId: string;
  index: number;
  tool: CatalogTool;
  onOpen: () => void;
}

export default function ToolCard({ sectionId, index: listIndex, tool, onOpen }: ToolCardProps) {
  const isTools = sectionId === 'tools';
  const index = artIndex(sectionId, tool.id, listIndex);
  const own = isTools ? TOOL_ART[tool.id] : undefined;
  const hero = own ? own.hero : isTools ? CH[index] : undefined; // tools past the drawn set get no repeated figure

  return (
    <button
      className="card"
      style={{ '--h': HUES[index % 7] } as CSSProperties}
      onClick={onOpen}
    >
      {hero && <Raw className="cpeek" html={char(hero)} />}
      <div className="card-top">
        <div className="tile">
          {isTools && <span className="tping" />}
          <Raw html={ic(sectionId, index)} style={{ display: 'contents' }} />
        </div>
        <span className="tag">{tool.tag}</span>
      </div>
      <div>
        <h3>{tool.name}</h3>
      </div>
      <p>{tool.description}</p>
      <div className="card-foot">
        <span className="status">
          <i className="dot" />
          Ready
        </span>
        <span className="open-link">Open →</span>
      </div>
    </button>
  );
}
